import { EmployeeAttendance } from "../../types/Attendance";
import { EmployeeAttendanceActionList } from "../actions/employeeAttendanceAction";
import { Action } from "../actions/types";

const initialValue: Array<EmployeeAttendance> = [];

export const employeeAttendanceReducer = (
  state: EmployeeAttendance[] = initialValue,
  action: Action,
): EmployeeAttendance[] => {
  switch (action.type) {
    case EmployeeAttendanceActionList.ADD_EMPLOYEE_ATTENDANCE:
      return [...state, action.data];

    case EmployeeAttendanceActionList.EDIT_EMPLOYEE_ATTENDANCE: {
      const updated = [...state];
      const index = updated.findIndex((att) => att.id === action.data.id);
      if (index > -1) {
        updated[index] = { ...action.data };
      }
      return updated;
    }

    case EmployeeAttendanceActionList.FETCH_EMPLOYEE_ATTENDANCE:
      return action.data ?? initialValue;

    case EmployeeAttendanceActionList.DELETE_EMPLOYEE_ATTENDANCE:
      return state.filter((att) => att.id !== action.data);

    default:
      return state;
  }
};
